export default __webpack_public_path__ + "static/media/search-icon.209b35a4.svg";